import { FC } from 'react';
import Description from './Description';
import Intro from './Intro';
import RecognizedBy from './RecognizedBy';

const Why: FC = () => (
    <div className="flex flex-col mx-auto items-center">
        <Intro />
        <Description />
        <RecognizedBy />
    </div>
);

export default Why;
